import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Payment method icons
import bkashLogo from "../assets/bkash.png";
import nogodLogo from "../assets/nogod.png";
import rocketLogo from "../assets/rocket.png";

// Preset amounts
const presetAmounts = [300, 500, 1000, 5000, 10000, 15000, 20000, 25000];

const DepositPage = () => {
  const navigate = useNavigate();

  // ================= STATES =================
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [methodLoading, setMethodLoading] = useState(true);

  const [selectedMethod, setSelectedMethod] = useState(null);
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");

 // ================= USER FUND HISTORY =================
const [fundHistory, setFundHistory] = useState([]);

useEffect(() => {
  const fetchHistory = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
if (!user || !user.id) return;
const userId = user.id;

      const res = await fetch(`https://api.earnmoney0.top/api/fund/history/${userId}`);
      const data = await res.json();

      if (data.success) {
        setFundHistory(data.history);
      }
    } catch (err) {
      console.error("Fetch fund history error:", err);
    }
  };

  fetchHistory();
}, []);

  // ================= FETCH PAYMENT METHODS =================
  useEffect(() => {
    const fetchMethods = async () => {
      try {
        const res = await fetch("https://api.earnmoney0.top/api/payment-methods");
        const data = await res.json();

        // শুধু Active method দেখাবে
        const activeMethods = data.filter(
          (m) => m.status === "active"
        );

        setPaymentMethods(activeMethods);
      } catch (err) {
        console.error("Payment method fetch error:", err);
      } finally {
        setMethodLoading(false);
      }
    };

    fetchMethods();
  }, []);

  // ================= HANDLERS =================
  const handleAmountChange = (e) => {
    const val = Number(e.target.value);
    setAmount(val);

    if (val < 300) {
      setError("Minimum deposit 300 BDT");
    } else {
      setError("");
    }
  };

  const handlePresetClick = (val) => {
    setAmount(val);
    if (val < 300) setError("Minimum deposit 300 BDT");
    else setError("");
  };

  const handleDeposit = () => {
  if (!selectedMethod) {
    alert("অনুগ্রহ করে বিকাশ / নগদ / রকেট সিলেক্ট করুন ✅");
    return;
  }

  if (!amount || amount < 300) {
    alert("অনুগ্রহ করে ৩০০ বা তার বেশি দিন ✅");
    return;
  }

  // Payment Page-এ method name এবং number পাঠানো
  const user = JSON.parse(localStorage.getItem("user"));
if (!user || !user.id) {
  alert("User not logged in!");
  return;
}

const userId = user._id;

// Payment Page-এ method name, number + userId পাঠানো
navigate(
  `/payment?amount=${amount}&methodName=${selectedMethod.name}&number=${selectedMethod.number}`
);
};

  // ================= UI =================
  return (
    <div style={styles.page}>
      {/* Header */}
      <div style={styles.header}>
        <button onClick={() => navigate(-1)} style={styles.backBtn}>
          ←
        </button>
        <h2 style={styles.headerTitle}>Deposit</h2>
      </div>

      {/* Notice */}
      <div style={styles.noticeCard}>
        <p>মিনিমাম ডিপোজিট ৩০০ টাকা</p>
      </div>

      {/* Payment Method Selection */}
      <div style={styles.card}>
        <h3 style={styles.cardTitle}>পেমেন্ট মেথড সিলেকশন</h3>

        <div style={styles.paymentGrid}>
  {methodLoading ? (
    <p>Loading...</p>
  ) : paymentMethods.length === 0 ? (
    <p style={{ color: "red", fontWeight: 600 }}>
      বর্তমানে এই সার্ভিসটি বন্ধ আছে
    </p>
  ) : (
    paymentMethods.map((method) => (
      <div
        key={method._id}
        onClick={() => setSelectedMethod(method)}
        style={{
          ...styles.paymentBox,
          borderColor:
            selectedMethod?._id === method._id ? "#16a34a" : "#ddd",
        }}
      >
        <img
          src={
            method.name === "বিকাশ"
              ? bkashLogo
              : method.name === "নগদ"
              ? nogodLogo
              : rocketLogo
          }
          alt={method.name}
          style={styles.paymentIcon}
        />
        <p>{method.name}</p>
        <small style={{ display: "block", fontSize: 12, color: "#555" }}>
          {method.number}
        </small>
      </div>
    ))
  )}
</div>
      </div>

      {/* Amount Section */}
      <div style={styles.card}>
        <h3 style={styles.cardTitle}>Amount</h3>

        <div style={styles.amountInputWrapper}>
          <span style={styles.currency}>৳</span>
          <input
            type="number"
            placeholder="টাকার সংখ্যা দিন"
            value={amount}
            onChange={handleAmountChange}
            style={styles.amountInput}
          />
        </div>

        {error && <p style={styles.errorText}>{error}</p>}

        <div style={styles.presetWrapper}>
          {presetAmounts.map((amt) => (
            <button
              key={amt}
              onClick={() => handlePresetClick(amt)}
              style={styles.presetBtn}
            >
              {amt}
            </button>
          ))}
        </div>
      </div>

      {/* Deposit Button */}
      <button onClick={handleDeposit} style={styles.depositBtn}>
        টাকা জমা করুন ✅
      </button>

      {/* History */}
      <div style={styles.card}>
        <h3 style={styles.cardTitle}>History</h3>
        {fundHistory.length === 0 ? (
          <p>No history yet</p>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <th>Date</th>
                <th>Method</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {fundHistory.map((item, i) => (
                <tr key={i} style={{ borderBottom: "1px solid #eee" }}>
                  <td>{item.date}</td>
                  <td>{item.method}</td>
                  <td>৳{item.amount}</td>
                  <td>{item.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

// ================= STYLES =================
const styles = {
  page: {
    minHeight: "100vh",
    background: "#f5f5f5",
    fontFamily: "'Hind Siliguri', sans-serif",
    padding: 15,
  },
  header: {
    background: "#7a0f7a",
    color: "#fff",
    padding: "12px 15px",
    display: "flex",
    alignItems: "center",
    gap: 10,
    borderRadius: 8,
  },
  backBtn: {
    background: "transparent",
    border: "none",
    color: "#fff",
    fontSize: 20,
    cursor: "pointer",
  },
  headerTitle: {
    margin: 0,
    fontSize: 20,
  },
  noticeCard: {
    background: "#fff",
    padding: 10,
    borderRadius: 8,
    margin: "15px 0",
    fontWeight: 500,
    textAlign: "center",
  },
  card: {
    background: "#fff",
    padding: 15,
    borderRadius: 12,
    marginBottom: 15,
  },
  cardTitle: {
    marginBottom: 10,
    fontWeight: 600,
    color: "#7a0f7a",
  },
  paymentGrid: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
  },
  paymentBox: {
    flex: "1 1 30%",
    border: "2px solid #ddd",
    borderRadius: 8,
    padding: 15,
    textAlign: "center",
    cursor: "pointer",
  },
  paymentIcon: {
    width: 50,
    height: 50,
    marginBottom: 8,
  },
  amountInputWrapper: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #ccc",
    borderRadius: 8,
    padding: "8px 12px",
  },
  currency: {
    fontWeight: 700,
    fontSize: 18,
  },
  amountInput: {
    border: "none",
    outline: "none",
    flex: 1,
    fontSize: 16,
  },
  errorText: {
    color: "#dc2626",
    marginTop: 6,
    fontSize: 13,
  },
  presetWrapper: {
    display: "flex",
    gap: 10,
    marginTop: 10,
    flexWrap: "wrap",
  },
  presetBtn: {
    border: "1px solid #2563eb",
    color: "#2563eb",
    padding: "6px 12px",
    borderRadius: 20,
    cursor: "pointer",
    background: "#fff",
  },
  depositBtn: {
    width: "100%",
    background: "#7a0f7a",
    color: "#fff",
    padding: 12,
    border: "none",
    borderRadius: 12,
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer",
  },
};

export default DepositPage;